<mat-card>
  <app-card-header
    [title]="'Filtros de luminarias'"
    icono="filter_alt"
    [botonCerrar]="true"
    (cerrar)="cancelar()"
  ></app-card-header>

  <mat-card-content class="card-content-crear">
    <!-- SECCIÓN: búsqueda por texto libre -->
    <app-content-card title="Buscar por texto" icon="search">
      <section class="inputs-group">
        <mat-form-field class="no-hint" style="width: 100%">
          <mat-label>Dirección</mat-label>
          <input
            matInput
            type="text"
            placeholder="Ej: Av. Rivadavia 1234"
            [(ngModel)]="direccion"
            (ngModelChange)="onTextoChange()"
          />
        </mat-form-field>
      </section>

      <section class="inputs-group">
        <mat-form-field class="no-hint" style="width: 100%">
          <mat-label>Identificación</mat-label>
          <input
            matInput
            type="text"
            placeholder="Ej: LUM-0421"
            [(ngModel)]="identificacion"
            (ngModelChange)="onTextoChange()"
          />
        </mat-form-field>
      </section>

      <section class="inputs-group">
        <mat-form-field class="no-hint" style="width: 100%">
          <mat-label>Dispositivo</mat-label>
          <input
            matInput
            type="text"
            placeholder="DevEUI o nombre"
            [(ngModel)]="dispositivo"
            (ngModelChange)="onTextoChange()"
          />
        </mat-form-field>
      </section>
    </app-content-card>

    <!-- SECCIÓN: agrupación y ubicación -->
    <app-content-card title="Agrupación y ubicación" icon="category">
      <section class="inputs-group">
        <div class="flm-campo" #boxSelect data-campo="grupos">
          <ng-select
            [items]="gruposDisponibles"
            bindLabel="nombre"
            bindValue="_id"
            placeholder="Grupos"
            notFoundText="Sin resultados"
            [multiple]="true"
            [searchable]="true"
            [closeOnSelect]="false"
            appendTo="body"
            [(ngModel)]="grupos"
            (change)="onSelectChange()"
            (open)="onSelectToggle()"
            (close)="onSelectToggle()"
          >
            <ng-template ng-option-tmp let-item="item">
              <span
                class="color-circle"
                [ngStyle]="{ 'background-color': item?.color || '#6b7280' }"
              ></span>
              {{ item?.nombre }}
            </ng-template>
            <ng-template ng-label-tmp let-item="item" let-clear="clear">
              <span
                class="ng-value-icon right irx-clickeable"
                role="button"
                tabindex="0"
                tooltip="Quitar"
                (click)="clear(item)"
                (keydown.enter)="clear(item)"
              >
                ×
              </span>
              <span
                class="color-circle"
                [ngStyle]="{ 'background-color': item?.color || '#6b7280' }"
              ></span>
              {{ item?.nombre }}
            </ng-template>
          </ng-select>
          @if (ocultos.grupos > 0) {
            <button
              type="button"
              class="irx-enlace flm-mas"
              [matMenuTriggerFor]="gruposMenu"
            >
              +{{ ocultos.grupos }} más
            </button>
            <mat-menu #gruposMenu="matMenu" class="chips-menu">
              <div class="chips-pop" (click)="$event.stopPropagation()">
                @for (g of gruposSel; track g._id) {
                  <span class="chip-pop">
                    <span
                      class="color-circle"
                      [ngStyle]="{ 'background-color': g.color || '#6b7280' }"
                    ></span>
                    <span class="chip-pop-label">{{ g.nombre }}</span>
                    <button
                      irxBotonIcono
                      tamano="mini"
                      (click)="quitarGrupo(g._id)"
                      tooltip="Quitar"
                    >
                      <mat-icon>close</mat-icon>
                    </button>
                  </span>
                }
              </div>
            </mat-menu>
          }
        </div>
      </section>

      <section class="inputs-group">
        <div class="flm-campo" #boxSelect data-campo="zonas">
          <ng-select
            [items]="zonasDisponibles"
            bindLabel="identificacion"
            bindValue="_id"
            placeholder="Zonas"
            notFoundText="Sin resultados"
            [multiple]="true"
            [searchable]="true"
            [closeOnSelect]="false"
            appendTo="body"
            [(ngModel)]="zonas"
            (change)="onSelectChange()"
            (open)="onSelectToggle()"
            (close)="onSelectToggle()"
          >
            <ng-template ng-option-tmp let-item="item">
              <span
                class="color-circle"
                [ngStyle]="{ 'background-color': item?.color || '#ffcc33' }"
              ></span>
              {{ item?.identificacion }}
            </ng-template>
            <ng-template ng-label-tmp let-item="item" let-clear="clear">
              <span
                class="ng-value-icon right irx-clickeable"
                role="button"
                tabindex="0"
                tooltip="Quitar"
                (click)="clear(item)"
                (keydown.enter)="clear(item)"
              >
                ×
              </span>
              <span
                class="color-circle"
                [ngStyle]="{ 'background-color': item?.color || '#ffcc33' }"
              ></span>
              {{ item?.identificacion }}
            </ng-template>
          </ng-select>
          @if (ocultos.zonas > 0) {
            <button
              type="button"
              class="irx-enlace flm-mas"
              [matMenuTriggerFor]="zonasMenu"
            >
              +{{ ocultos.zonas }} más
            </button>
            <mat-menu #zonasMenu="matMenu" class="chips-menu">
              <div class="chips-pop" (click)="$event.stopPropagation()">
                @for (z of zonasSel; track z._id) {
                  <span class="chip-pop">
                    <span
                      class="color-circle"
                      [ngStyle]="{ 'background-color': z.color || '#ffcc33' }"
                    ></span>
                    <span class="chip-pop-label">{{ z.identificacion }}</span>
                    <button
                      irxBotonIcono
                      tamano="mini"
                      (click)="quitarZona(z._id)"
                      tooltip="Quitar"
                    >
                      <mat-icon>close</mat-icon>
                    </button>
                  </span>
                }
              </div>
            </mat-menu>
          }
        </div>
      </section>

      @if (helper.tienePermiso('Administración - Ver clientes')) {
        <section class="inputs-group">
          <div class="flm-campo" #boxSelect data-campo="clientes">
            <app-cliente-selector
              [multiple]="true"
              placeholder="Clientes"
              [(ngModel)]="clientes"
              (ngModelChange)="onSelectChange()"
              (clientesChange)="clientesObjs = $event"
              [filterModules]="['moduloLuminarias']"
              margin="0"
            ></app-cliente-selector>
            @if (ocultos.clientes > 0) {
              <button
                type="button"
                class="irx-enlace flm-mas"
                [matMenuTriggerFor]="clientesMenu"
              >
                +{{ ocultos.clientes }} más
              </button>
              <mat-menu #clientesMenu="matMenu" class="chips-menu">
                <div class="chips-pop" (click)="$event.stopPropagation()">
                  @for (c of clientesObjs; track c._id) {
                    <span class="chip-pop">
                      <span class="chip-pop-label">{{ c.nombre }}</span>
                      <button
                        irxBotonIcono
                        tamano="mini"
                        (click)="quitarCliente(c._id)"
                        tooltip="Quitar"
                      >
                        <mat-icon>close</mat-icon>
                      </button>
                    </span>
                  }
                </div>
              </mat-menu>
            }
          </div>
        </section>
      }
    </app-content-card>
  </mat-card-content>

  <mat-card-actions class="actions-create">
    <button irxBoton="secundario" type="button" (click)="limpiar()">
      <mat-icon>filter_alt_off</mat-icon>
      Limpiar
    </button>
    <button irxBoton="principal" type="button" (click)="aplicar()">
      <mat-icon>check</mat-icon>
      Aplicar
    </button>
  </mat-card-actions>
</mat-card>
